module.exports = __webpack_public_path__ + "img/lg-付款成功.91cb59c4.svg";